import { CalendarManager, MergersAndAcquisitions, ISetParams } from '@benzinga/calendar-manager';
import { Session } from '@benzinga/session';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

const fetchMA = (session: Session, params: ISetParams = {}, pageSize = 100): Promise<MergersAndAcquisitions[]> => {
  return session
    .getManager(CalendarManager)
    .getCalendarData('ma', { ...params, pageSize })
    .then(res => {
      if (res.ok) {
        return res.ok.sort((a, b) => {
          const dateA = new Date(a.date || 0).getTime();
          const dateB = new Date(b.date || 0).getTime();
          return dateB - dateA;
        });
      }
      return [];
    })
    .catch(error => {
      logCalendarFetchFailure('m-a', error);
      return [];
    });
};

export { fetchMA };
